import { TaskData } from "src/app/pages/stock/stock.service";

export class NextPreAction {
    Action: string;
    CurrentValue: string;
    ColumnName: string;
    taskFilterData: TaskData[]; 
}

export class NextPreValue {
    prevValue: string;
    nextValue: string;
    currentValue: string;
    columnName: string;
    selectionId: string;
    action: string;
}